module.exports = {
	"units": [
		{
			"id": "hy",
			"title": "hydrogen storage",
			"headline": "Wasserstoff-Speicher",
			"description": "Der Wasserstoffspeicher wird aktuell mit einer Leistung von <%= status.flows['pv-el'] + status.flows['bt-el'] %> kW geladen. Sein Fuellstand betraegt <%= status.units.hy / unit.max * 100 %>%.",
			"min": 0,
			"max": 350,
			"unit": "kWh",
			"headlinePos": "top"
		},
		{
			"id": "el",
			"title": "electrolyseur",
			"headline": "Elektrolyseur",
			"description": "Der Eletrolyseur wandelt aktuell <%= status.flows['pv-el'] + status.flows['bt-el'] %> kW an Solarstrom in Wasserstoff um.",
			"min": 0,
			"max": 2.6,
			"unit": "kW",
			"headlinePos": "top"
		},
		{
			"id": "fc",
			"title": "fuel cell",
			"headline": "Brennstoffzelle",
			"description": "Die Brennstoffzelle wandelt aktuell Wasserstoff in <%= status.flows['fc-ld'] + status.flows['fc-bt'] %> kW Strom um.",
			"min": 0,
			"max": 1.5,
			"unit": "kW",
			"headlinePos": "bottom"
		},
		{
			"id": "pv",
			"title": "photovoltaic energy",
			"headline": "Solaranlage",
			"description": "Die Solaranlage generiert aktuell eine Leistung von <%= status.flows['pv-el'] + status.flows['pv-bt'] + status.flows['pv-ld']%> kW.",
			"min": 0,
			"max": 10,
			"unit": "kW",
			"headlinePos": "top"
		},
		{
			"id": "ld",
			"title": "electric load",
			"headline": "Stromverbrauch",
			"description": "Der Haushalt verbraucht fuer Strom aktuell <%= status.flows['pv-ld'] + status.flows['bt-ld'] + status.flows['fc-ld']%> kW.",
			"min": 0,
			"max": 10,
			"unit": "kW",
			"headlinePos": "bottom"
		},
		{
			"id": "bt",
			"title": "battery",
			"headline": "Batterie",
			"description": "Die Batterie wird aktuell mit einer Leistung von <%= status.flows['fc-bt'] + status.flows['pv-bt']%> kW geladen. Ihr Fuellstand betraegt <%= status.units.bt / unit.max * 100 %>%.",
			"min": 0,
			"max": 25,
			"unit": "kWh",
			"headlinePos": "top"
		},
		{
			"id": "ht",
			"title": "heating",
			"headline": "Waermebeitrag",
			"description": "Der Waermebeitrag betraegt aktuell <%= status.units['ht']%> kW.",
			"min": 0,
			"max": 1.9,
			"unit": "kW",
			"headlinePos": "bottom"
		}
	],
	"flows": [
		{
			"id": "pv-ld",
			"title": "Photovoltaic collector direct supply.",
			"from": "pv",
			"to": "ld",
			"min": 0,
			"max": 10
		},
		{
			"id": "pv-bt",
			"title": "pv-bt",
			"from": "pv",
			"to": "bt",
			"min": 0,
			"max": 7.4
		},
		{
			"id": "bt-ld",
			"title": "bt-ld",
			"from": "bt",
			"to": "ld",
			"min": 0,
			"max": 10
		},
		{
			"id": "pv-el",
			"title": "pv-el",
			"from": "pv",
			"to": "el",
			"min": 0,
			"max": 2.6
		},
		{
			"id": "fc-ld",
			"title": "fc-ld",
			"from": "fc",
			"to": "ld",
			"min": 0,
			"max": 1.5
		},
		{
			"id": "fc-bt",
			"title": "fc-bt",
			"from": "fc",
			"to": "bt",
			"min": 0,
			"max": 1.5
		},
		{
			"id": "bt-el",
			"title": "bt-el",
			"from": "bt",
			"to": "el",
			"min": 0,
			"max": 0
		},
		{
			"id": "fc-ht",
			"title": "fc-ht",
			"from": "fc",
			"to": "ht",
			"min": 0,
			"max": 1.9
		},
		{
			"id": "el-ht",
			"title": "el-ht",
			"from": "el",
			"to": "ht",
			"min": 0,
			"max": 0.8
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/config/picea.json
// module id = ./src/config/picea.json
// module chunks = 0